import React, { useState, useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { Box, CircularProgress, Typography, Button } from "@mui/material";
import { useFirebase } from "../../context/ApiContext";
import { ImageBaseUrlProvider } from "../../context/ImageBaseUrlContext";
import { MapFullscreenContext } from "../../context/MapFullscreenContext";
import { ViewerContext } from "../../context/ViewerContext";
import { getApiOrigin } from "../../utils/api";
import { trackEvent } from "../../utils/analytics";
import { guideLandingPath } from "../../data/guideLandings";
import SeoHead from "../Seo/SeoHead";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import LockIcon from "@mui/icons-material/Lock";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt";
import {
	Stage,
	Layer,
	Image as KonvaImage,
	Text as KonvaText,
	TextPath as KonvaTextPath,
	Group,
} from "react-konva";
import { computeStickerTextLayout } from "../CustomStickers/fitText";
import Template1 from "../templates/Template1";
import Template2 from "../templates/Template2";
import Template3 from "../templates/Template3";
import Template4 from "../templates/Template4";
import Template5 from "../templates/Template5";
import Template6 from "../templates/Template6";
import Template7 from "../templates/Template7";
import Template8 from "../templates/Template8";
import Template9 from "../templates/Template9";
import Template10 from "../templates/Template10";
import Template11 from "../templates/Template11";
import Template12 from "../templates/Template12";
import Template13 from "../templates/Template13";
import Template14 from "../templates/Template14";
import Template15 from "../templates/Template15";
import Template16 from "../templates/Template16";
import Template17 from "../templates/Template17";
import Template18 from "../templates/Template18";
import Template19 from "../templates/Template19";
import Template20 from "../templates/Template20";
import Template21 from "../templates/Template21";
import Template22 from "../templates/Template22";
import Template23 from "../templates/Template23";
import Template24 from "../templates/Template24";
import Template25 from "../templates/Template25";
import Template26 from "../templates/Template26";
import Template27 from "../templates/Template27";
import Template28 from "../templates/Template28";
import Template29 from "../templates/Template29";
import Template30 from "../templates/Template30";
import Template31 from "../templates/Template31";
import Template32 from "../templates/Template32";
import Template33 from "../templates/Template33";
import Template34 from "../templates/Template34";
import Template35 from "../templates/Template35";
import Template36 from "../templates/Template36";
import Template37 from "../templates/Template37";
import Template38 from "../templates/Template38";
import Template39 from "../templates/Template39";
import Template40 from "../templates/Template40";
import Template41 from "../templates/Template41";
import Template42 from "../templates/Template42";
import Template43 from "../templates/Template43";
import Template50 from "../templates/Template50";
import Template51 from "../templates/Template51";
import Template52 from "../templates/Template52";
import Template53 from "../templates/Template53";
import Template54 from "../templates/Template54";
import Template55 from "../templates/Template55";
import Template56 from "../templates/Template56";
import Template57 from "../templates/Template57";
import Template58 from "../templates/Template58";
import Template59 from "../templates/Template59";
import Template60 from "../templates/Template60";
import Template61 from "../templates/Template61";
import Template62 from "../templates/Template62";
import Template63 from "../templates/Template63";
import Template64 from "../templates/Template64";
import Template65 from "../templates/Template65";
import Template70 from "../templates/Template70";
import Template71 from "../templates/Template71";
import Template72 from "../templates/Template72";
import Template73 from "../templates/Template73";
import Template74 from "../templates/Template74";
import Template75 from "../templates/Template75";
import Template76 from "../templates/Template76";
import Template77 from "../templates/Template77";
import Template78 from "../templates/Template78";
import Template79 from "../templates/Template79";
import Template80 from "../templates/Template80";
import Template81 from "../templates/Template81";
import Template82 from "../templates/Template82";
import Template83 from "../templates/Template83";
import Template84 from "../templates/Template84";
import Template85 from "../templates/Template85";
import Template86 from "../templates/Template86";
import Template87 from "../templates/Template87";
import Template88 from "../templates/Template88";
import Template89 from "../templates/Template89";
import Template90 from "../templates/Template90";
import Template91 from "../templates/Template91";
import Template92 from "../templates/Template92";
import Template93 from "../templates/Template93";
import Template94 from "../templates/Template94";
import Template95 from "../templates/Template95";
import Template96 from "../templates/Template96";
import Template97 from "../templates/Template97";
import Template98 from "../templates/Template98";
import Template99 from "../templates/Template99";
import Template101 from "../templates/Template101";
import Template102 from "../templates/Template102";
import Template103 from "../templates/Template103";
import Template104 from "../templates/Template104";
import Template105 from "../templates/Template105";
import Template106 from "../templates/Template106";
import Template110 from "../templates/Template110";
import Template111 from "../templates/Template111";
import Template112 from "../templates/Template112";
import Template113 from "../templates/Template113";
import Template114 from "../templates/Template114";
import Template115 from "../templates/Template115";
import Template116 from "../templates/Template116";
import Template117 from "../templates/Template117";
import Template118 from "../templates/Template118";
import Template119 from "../templates/Template119";
import Template120 from "../templates/Template120";
import Template121 from "../templates/Template121";
import Template122 from "../templates/Template122";
import Template123 from "../templates/Template123";
import Template124 from "../templates/Template124";
import Template125 from "../templates/Template125";
import Template126 from "../templates/Template126";
import Template127 from "../templates/Template127";
import Template128 from "../templates/Template128";
import Template129 from "../templates/Template129";
import Template130 from "../templates/Template130";
import Template131 from "../templates/Template131";
import Template132 from "../templates/Template132";
import Template133 from "../templates/Template133";
import Template134 from "../templates/Template134";
import Template144 from "../templates/Template144";
import Template145 from "../templates/Template145";
import Template135 from "../templates/Template135";
import Template136 from "../templates/Template136";
import Template137 from "../templates/Template137";
import Template138 from "../templates/Template138";
import Template139 from "../templates/Template139";
import Template140 from "../templates/Template140";
import Template141 from "../templates/Template141";
import Template142 from "../templates/Template142";
import Template143 from "../templates/Template143";
import Template146 from "../templates/Template146";
import Template147 from "../templates/Template147";
// París templates (150-167)
import Template150 from "../templates/Template150";
import Template151 from "../templates/Template151";
import Template152 from "../templates/Template152";
import Template153 from "../templates/Template153";
import Template154 from "../templates/Template154";
import Template155 from "../templates/Template155";
import Template156 from "../templates/Template156";
import Template157 from "../templates/Template157";
import Template158 from "../templates/Template158";
import Template159 from "../templates/Template159";
import Template160 from "../templates/Template160";
import Template161 from "../templates/Template161";
import Template162 from "../templates/Template162";
import Template163 from "../templates/Template163";
import Template164 from "../templates/Template164";
import Template165 from "../templates/Template165";
import Template166 from "../templates/Template166";
import Template167 from "../templates/Template167";
import Template168 from "../templates/Template168";
import Template169 from "../templates/Template169";
import Template170 from "../templates/Template170";
import Template171 from "../templates/Template171";
import Template172 from "../templates/Template172";
import Template173 from "../templates/Template173";
import Template174 from "../templates/Template174";
import Template175 from "../templates/Template175";
import Template176 from "../templates/Template176";
import Template177 from "../templates/Template177";
import Template178 from "../templates/Template178";
import Template179 from "../templates/Template179";
import Template180 from "../templates/Template180";
import Template181 from "../templates/Template181";
import Template182 from "../templates/Template182";
import Template183 from "../templates/Template183";
import Template184 from "../templates/Template184";
import Template185 from "../templates/Template185";
import Template186 from "../templates/Template186";
import Template187 from "../templates/Template187";
import Template188 from "../templates/Template188";
import Template189 from "../templates/Template189";
import Template190 from "../templates/Template190";
import Template191 from "../templates/Template191";
import Template192 from "../templates/Template192";
import Template193 from "../templates/Template193";
import Template194 from "../templates/Template194";
import Template195 from "../templates/Template195";
import Template196 from "../templates/Template196";
import Template197 from "../templates/Template197";
import Template198 from "../templates/Template198";
import Template199 from "../templates/Template199";
import Template200 from "../templates/Template200";
import Template201 from "../templates/Template201";
import Template202 from "../templates/Template202";
import Template203 from "../templates/Template203";
import Template204 from "../templates/Template204";
import Template205 from "../templates/Template205";
import Template206 from "../templates/Template206";
import Template207 from "../templates/Template207";
import Template208 from "../templates/Template208";
import Template209 from "../templates/Template209";
import Template210 from "../templates/Template210";
import Template211 from "../templates/Template211";
import Template212 from "../templates/Template212";
import Template213 from "../templates/Template213";
import Template214 from "../templates/Template214";
import Template215 from "../templates/Template215";
import Template216 from "../templates/Template216";
import Template217 from "../templates/Template217";
import Template218 from "../templates/Template218";
import Template219 from "../templates/Template219";
import Template220 from "../templates/Template220";
import Template221 from "../templates/Template221";
import Template222 from "../templates/Template222";
import Template223 from "../templates/Template223";
import Template224 from "../templates/Template224";
import Template225 from "../templates/Template225";
import Template226 from "../templates/Template226";
import Template227 from "../templates/Template227";
import Template228 from "../templates/Template228";
import Template229 from "../templates/Template229";
import Template230 from "../templates/Template230";
import Template231 from "../templates/Template231";
import Template232 from "../templates/Template232";
import Template233 from "../templates/Template233";
import Template246 from "../templates/Template246";
import Template247 from "../templates/Template247";
import Template248 from "../templates/Template248";
import Template249 from "../templates/Template249";
import Template250 from "../templates/Template250";
import Template251 from "../templates/Template251";
import Template252 from "../templates/Template252";
import Template253 from "../templates/Template253";
import Template254 from "../templates/Template254";
import Template255 from "../templates/Template255";
import Template256 from "../templates/Template256";
import Template257 from "../templates/Template257";
import Template258 from "../templates/Template258";
import Template259 from "../templates/Template259";
import Template260 from "../templates/Template260";
import Template261 from "../templates/Template261";
import Template262 from "../templates/Template262";
import Template263 from "../templates/Template263";
import Template264 from "../templates/Template264";
import Template265 from "../templates/Template265";
import Template266 from "../templates/Template266";
import Template267 from "../templates/Template267";
import Template268 from "../templates/Template268";
import Template269 from "../templates/Template269";
import Template270 from "../templates/Template270";
import Template271 from "../templates/Template271";
import Template272 from "../templates/Template272";
import Template273 from "../templates/Template273";
import Template274 from "../templates/Template274";
import Template275 from "../templates/Template275";
import Template276 from "../templates/Template276";
import Template277 from "../templates/Template277";
import Template278 from "../templates/Template278";
import Template279 from "../templates/Template279";
import Template280 from "../templates/Template280";
import Template281 from "../templates/Template281";
import Template282 from "../templates/Template282";
import Template283 from "../templates/Template283";
import Template284 from "../templates/Template284";
import Template285 from "../templates/Template285";
import Template286 from "../templates/Template286";
import Template287 from "../templates/Template287";
import Template288 from "../templates/Template288";
import Template289 from "../templates/Template289";
import Template290 from "../templates/Template290";
import Template291 from "../templates/Template291";
import Template293 from "../templates/Template293";
import Template294 from "../templates/Template294";
import Template295 from "../templates/Template295";
import Template296 from "../templates/Template296";
import Template297 from "../templates/Template297";
import Template298 from "../templates/Template298";
import Template299 from "../templates/Template299";
import Template300 from "../templates/Template300";
import Template301 from "../templates/Template301";
import Template302 from "../templates/Template302";
import Template303 from "../templates/Template303";
import Template304 from "../templates/Template304";
import Template305 from "../templates/Template305";
import Template309 from "../templates/Template309";
import Template310 from "../templates/Template310";
import Template311 from "../templates/Template311";
import Template312 from "../templates/Template312";
import Template313 from "../templates/Template313";
import Template314 from "../templates/Template314";
import Template315 from "../templates/Template315";
import Template316 from "../templates/Template316";
import Template317 from "../templates/Template317";
import Template318 from "../templates/Template318";
import Template319 from "../templates/Template319";
import Template324 from "../templates/Template324";
import Template325 from "../templates/Template325";
import Template326 from "../templates/Template326";
import Template327 from "../templates/Template327";
import Template328 from "../templates/Template328";
import Template330 from "../templates/Template330";
import Template331 from "../templates/Template331";
import Template332 from "../templates/Template332";
import Template333 from "../templates/Template333";
import Template334 from "../templates/Template334";
import Template335 from "../templates/Template335";
import Template336 from "../templates/Template336";
import Template337 from "../templates/Template337";
import Template338 from "../templates/Template338";
import Template339 from "../templates/Template339";
import Template340 from "../templates/Template340";
import Note from "../Note/Note";
// Mapa único templateId → Component. El servidor devuelve templateId por página; se resuelve aquí.
const templatesById = {
	1: Template1,
	2: Template2,
	3: Template3,
	4: Template4,
	5: Template5,
	6: Template6,
	7: Template7,
	8: Template8,
	9: Template9,
	10: Template10,
	11: Template11,
	12: Template12,
	13: Template13,
	14: Template14,
	15: Template15,
	16: Template16,
	17: Template17,
	18: Template18,
	19: Template19,
	20: Template20,
	21: Template21,
	22: Template22,
	23: Template23,
	24: Template24,
	25: Template25,
	26: Template26,
	27: Template27,
	28: Template28,
	29: Template29,
	30: Template30,
	31: Template31,
	32: Template32,
	33: Template33,
	34: Template34,
	35: Template35,
	36: Template36,
	37: Template37,
	38: Template38,
	39: Template39,
	40: Template40,
	41: Template41,
	42: Template42,
	43: Template43,
	50: Template50,
	51: Template51,
	52: Template52,
	53: Template53,
	54: Template54,
	55: Template55,
	56: Template56,
	57: Template57,
	58: Template58,
	59: Template59,
	60: Template60,
	61: Template61,
	62: Template62,
	63: Template63,
	64: Template64,
	65: Template65,
	70: Template70,
	71: Template71,
	72: Template72,
	73: Template73,
	74: Template74,
	75: Template75,
	76: Template76,
	77: Template77,
	78: Template78,
	79: Template79,
	80: Template80,
	81: Template81,
	82: Template82,
	83: Template83,
	84: Template84,
	85: Template85,
	86: Template86,
	87: Template87,
	88: Template88,
	89: Template89,
	90: Template90,
	91: Template91,
	92: Template92,
	93: Template93,
	94: Template94,
	95: Template95,
	96: Template96,
	97: Template97,
	98: Template98,
	99: Template99,
	101: Template101,
	102: Template102,
	103: Template103,
	104: Template104,
	105: Template105,
	106: Template106,
	110: Template110,
	111: Template111,
	112: Template112,
	113: Template113,
	114: Template114,
	115: Template115,
	116: Template116,
	117: Template117,
	118: Template118,
	119: Template119,
	120: Template120,
	121: Template121,
	122: Template122,
	123: Template123,
	124: Template124,
	125: Template125,
	126: Template126,
	127: Template127,
	128: Template128,
	129: Template129,
	130: Template130,
	131: Template131,
	132: Template132,
	133: Template133,
	134: Template134,
	144: Template144,
	145: Template145,
	135: Template135,
	136: Template136,
	137: Template137,
	138: Template138,
	139: Template139,
	140: Template140,
	141: Template141,
	142: Template142,
	143: Template143,
	146: Template146,
	147: Template147,
	// París templates (150-167)
	150: Template150,
	151: Template151,
	152: Template152,
	153: Template153,
	154: Template154,
	155: Template155,
	156: Template156,
	157: Template157,
	158: Template158,
	159: Template159,
	160: Template160,
	161: Template161,
	162: Template162,
	163: Template163,
	164: Template164,
	165: Template165,
	166: Template166,
	167: Template167,
	168: Template168,
	169: Template169,
	170: Template170,
	171: Template171,
	172: Template172,
	173: Template173,
	174: Template174,
	175: Template175,
	176: Template176,
	177: Template177,
	178: Template178,
	179: Template179,
	180: Template180,
	181: Template181,
	182: Template182,
	183: Template183,
	184: Template184,
	185: Template185,
	186: Template186,
	187: Template187,
	188: Template188,
	189: Template189,
	190: Template190,
	191: Template191,
	192: Template192,
	193: Template193,
	194: Template194,
	195: Template195,
	196: Template196,
	197: Template197,
	198: Template198,
	199: Template199,
	200: Template200,
	201: Template201,
	202: Template202,
	203: Template203,
	204: Template204,
	205: Template205,
	206: Template206,
	207: Template207,
	208: Template208,
	209: Template209,
	210: Template210,
	211: Template211,
	212: Template212,
	213: Template213,
	214: Template214,
	215: Template215,
	216: Template216,
	217: Template217,
	218: Template218,
	219: Template219,
	220: Template220,
	221: Template221,
	222: Template222,
	223: Template223,
	224: Template224,
	225: Template225,
	226: Template226,
	227: Template227,
	228: Template228,
	229: Template229,
	230: Template230,
	231: Template231,
	232: Template232,
	233: Template233,
	// Bélgica: Día 1 Bruselas (Page3 - Template246), Page4 (247), Page4Mapa (248), Page6 (249), Page7 (250)
	246: Template246,
	247: Template247,
	248: Template248,
	249: Template249,
	250: Template250,
	251: Template251,
	252: Template252,
	253: Template253,
	254: Template254,
	255: Template255,
	256: Template256,
	257: Template257,
	258: Template258,
	259: Template259,
	260: Template260,
	261: Template261,
	262: Template262,
	263: Template263,
	264: Template264,
	265: Template265,
	266: Template266,
	267: Template267,
	268: Template268,
	269: Template269,
	270: Template270,
	271: Template271,
	272: Template272,
	273: Template273,
	274: Template274,
	275: Template275,
	276: Template276,
	277: Template277,
	278: Template278,
	279: Template279,
	280: Template280,
	281: Template281,
	282: Template282,
	283: Template283,
	284: Template284,
	285: Template285,
	286: Template286,
	287: Template287,
	288: Template288,
	289: Template289,
	290: Template290,
	291: Template291,
	293: Template293,
	294: Template294,
	295: Template295,
	296: Template296,
	297: Template297,
	298: Template298,
	299: Template299,
	300: Template300,
	301: Template301,
	302: Template302,
	303: Template303,
	304: Template304,
	305: Template305,
	309: Template309,
	310: Template310,
	311: Template311,
	312: Template312,
	313: Template313,
	314: Template314,
	315: Template315,
	316: Template316,
	317: Template317,
	318: Template318,
	319: Template319,
	324: Template324,
	325: Template325,
	326: Template326,
	327: Template327,
	328: Template328,
	330: Template330,
	331: Template331,
	332: Template332,
	333: Template333,
	334: Template334,
	335: Template335,
	336: Template336,
	337: Template337,
	338: Template338,
	339: Template339,
	340: Template340,
	237: Template220,
	239: Template220,
	242: Template220,
	245: Template220,
};

const Viewer = () => {
	const { token, guideId, pageNum: pageNumParam } = useParams();
	const navigate = useNavigate();
	const location = useLocation();
	const {
		getSharedGuide,
		getPrebuiltGuidePreview,
		updateSharedGuidePage,
		getStickerAssetUrl,
		getAuthenticatedUrl,
	} = useFirebase();
	const isPrebuilt = Boolean(guideId);
	const [loading, setLoading] = useState(true);
	const [project, setProject] = useState(null);
	const [pages, setPages] = useState([]);
	const [previewAccess, setPreviewAccess] = useState(null); // { hasFullAccess, isLimited, totalPages, visiblePages } desde API preview
	const pageNumFromUrl = pageNumParam ? parseInt(pageNumParam, 10) : 1;
	const currentPageIndex = Math.max(
		0,
		isNaN(pageNumFromUrl) ? 0 : pageNumFromUrl - 1,
	);
	const prevPageIndexRef = useRef(currentPageIndex);
	const direction =
		currentPageIndex >= prevPageIndexRef.current ? "next" : "prev";
	const [error, setError] = useState(null);
	const [errorType, setErrorType] = useState(null); // 'not_found', 'private', 'forbidden'
	const [isSharedPublic, setIsSharedPublic] = useState(false);
	const [mapFullscreen, setMapFullscreen] = useState(false); // true cuando un template de mapa está en vista grande → ocultar "volver atrás"
	const [loadedImages, setLoadedImages] = useState({});
	const [fontsReadyKey, setFontsReadyKey] = useState(0);
	const touchStartX = useRef(0);
	const touchStartY = useRef(0);
	// Dimensiones del canvas (como en StickerApp): medidas numéricas y ResizeObserver
	const [canvasDimensions, setCanvasDimensions] = useState({
		width: 550,
		height: 765, //550 * (29.7 / 21),
	});
	// Rects de bloques [data-block-id] en coordenadas del Stage (como StickerApp) para anclaje de stickers/textos
	const [blockRects, setBlockRects] = useState({});
	const viewerPageInnerRef = useRef(null);
	const canvasContainerRef = useRef(null);
	const templateContainerRef = useRef(null);
	const pageContentRef = useRef(null);

	// Bloquear scroll en body/html en iOS para que el scroll quede solo en .viewer-page-content
	// y no se "enganche" en la ventana al mostrar/ocultar barra de URL
	useEffect(() => {
		const html = document.documentElement;
		const body = document.body;
		html.classList.add("viewer-active");
		body.classList.add("viewer-active");
		const onVisibilityChange = () => {
			if (document.visibilityState === "visible") {
				window.scrollTo(0, 0);
				if (body) body.scrollTop = 0;
				if (html) html.scrollTop = 0;
				const el = pageContentRef.current || document.querySelector(".viewer-page-content");
				if (el && el.scrollTop !== 0) el.scrollTo({ top: 0, behavior: "auto" });
			}
		};
		document.addEventListener("visibilitychange", onVisibilityChange);
		return () => {
			document.removeEventListener("visibilitychange", onVisibilityChange);
			html.classList.remove("viewer-active");
			body.classList.remove("viewer-active");
			window.scrollTo(0, 0);
			if (body) body.scrollTop = 0;
			if (html) html.scrollTop = 0;
		};
	}, []);
	// offsetInPixels: si true, offsetX/offsetY son píxeles desde el punto de anclaje; si false/undefined, porcentaje (compat).
	const getPositionFromAnchor = (
		anchor,
		offsetX,
		offsetY,
		elementWidth,
		elementHeight,
		canvasWidth,
		canvasHeight,
		offsetInPixels,
	) => {
		const px = (val, dim) => (offsetInPixels ? val : (val / 100) * dim);
		let pixelX, pixelY;

		if (anchor.includes("left")) {
			pixelX = px(offsetX, canvasWidth);
		} else if (anchor.includes("right")) {
			const rightEdge = canvasWidth - px(offsetX, canvasWidth);
			pixelX = rightEdge - elementWidth;
		} else if (anchor.includes("center") || anchor === "center") {
			const centerX = canvasWidth / 2 + px(offsetX, canvasWidth);
			pixelX = centerX - elementWidth / 2;
		} else {
			pixelX = px(offsetX, canvasWidth);
		}

		if (anchor.includes("top")) {
			pixelY = px(offsetY, canvasHeight);
		} else if (anchor.includes("bottom")) {
			const bottomEdge = canvasHeight - px(offsetY, canvasHeight);
			pixelY = bottomEdge - elementHeight;
		} else if (anchor === "center" || anchor.includes("center")) {
			const centerY = canvasHeight / 2 + px(offsetY, canvasHeight);
			pixelY = centerY - elementHeight / 2;
		} else {
			pixelY = px(offsetY, canvasHeight);
		}

		return { x: pixelX, y: pixelY };
	};

	// Dimensiones del texto en píxeles: si tiene widthPercent/heightPercent escala con el canvas
	const getTextDimensions = (t) => {
		const cw = canvasDimensions.width || 800;
		const ch = canvasDimensions.height || 1000;
		const width =
			t?.widthPercent != null && cw > 0
				? (t.widthPercent / 100) * cw
				: (t?.width ?? 0);
		const height =
			t?.heightPercent != null && ch > 0
				? (t.heightPercent / 100) * ch
				: (t?.height ?? 0);
		return { width, height };
	};

	// fontSize ligado a la template cuando hay fontSizePercent
	const getTextFontSize = (t) => {
		const cw = canvasDimensions.width || 800;
		if (t?.fontSizePercent != null && cw > 0) {
			return (t.fontSizePercent / 100) * cw;
		}
		return t?.fontSize ?? 16;
	};

	const getTextPixelPosition = (t) => {
		const dims = getTextDimensions(t);
		const visibleW = dims.width * (t?.scaleX || 1);
		const visibleH = dims.height * (t?.scaleY || 1);
		const cw = canvasDimensions.width || 800;
		const ch = canvasDimensions.height || 1000;

		// Anclaje a bloque (como en StickerApp)
		if (
			t?.anchorType === "block" &&
			t?.anchorBlockId &&
			blockRects[t.anchorBlockId]
		) {
			const r = blockRects[t.anchorBlockId];
			const px = r.left + (r.width * (t.blockOffsetXPercent ?? 0)) / 100;
			const py = r.top + (r.height * (t.blockOffsetYPercent ?? 0)) / 100;
			return { x: px, y: py };
		}
		if (t?.anchor && t?.offsetX !== undefined && t?.offsetY !== undefined) {
			return getPositionFromAnchor(
				t.anchor,
				t.offsetX,
				t.offsetY,
				visibleW,
				visibleH,
				cw,
				ch,
				t.offsetInPixels,
			);
		}
		if (t?.xPercent !== undefined && t?.yPercent !== undefined) {
			return { x: (t.xPercent / 100) * cw, y: (t.yPercent / 100) * ch };
		}
		return { x: t?.x || 0, y: t?.y || 0 };
	};

	// Posición y tamaño de stickers: misma lógica que StickerApp (anchor/offset y widthPercent/aspectRatio)
	// para que la altura/posición coincida entre editor y viewer (p. ej. travel kit).
	const getStickerScaledSize = (sticker) => {
		const cw = canvasDimensions.width || 800;
		if (
			typeof sticker.widthPercent === "number" &&
			!isNaN(sticker.widthPercent) &&
			typeof sticker.aspectRatio === "number" &&
			!isNaN(sticker.aspectRatio) &&
			cw > 0
		) {
			const width = (sticker.widthPercent / 100) * cw;
			const height = width * sticker.aspectRatio;
			if (!isNaN(width) && !isNaN(height) && width > 0 && height > 0) {
				return { width, height };
			}
		}
		const fallbackW = sticker.width ?? 80;
		const fallbackH = sticker.height ?? 80;
		return {
			width: isNaN(fallbackW) ? 80 : fallbackW,
			height: isNaN(fallbackH) ? 80 : fallbackH,
		};
	};

	const getStickerPixelPosition = (sticker, stickerWidth, stickerHeight) => {
		const cw = canvasDimensions.width || 800;
		const ch = canvasDimensions.height || 1000;
		// Anclaje a bloque (como en StickerApp): posición relativa a [data-block-id]
		if (
			sticker.anchorType === "block" &&
			sticker.anchorBlockId &&
			blockRects[sticker.anchorBlockId]
		) {
			const r = blockRects[sticker.anchorBlockId];
			const px = r.left + (r.width * (sticker.blockOffsetXPercent ?? 0)) / 100;
			const py = r.top + (r.height * (sticker.blockOffsetYPercent ?? 0)) / 100;
			return { x: px, y: py };
		}
		// Anclaje a página (como en StickerApp)
		if (
			sticker.anchorType === "page" &&
			sticker.anchor &&
			sticker.offsetX !== undefined &&
			sticker.offsetY !== undefined
		) {
			return getPositionFromAnchor(
				sticker.anchor,
				sticker.offsetX,
				sticker.offsetY,
				stickerWidth,
				stickerHeight,
				cw,
				ch,
				sticker.offsetInPixels ?? false,
			);
		}
		if (sticker.xPercent !== undefined && sticker.yPercent !== undefined) {
			return {
				x: (sticker.xPercent / 100) * cw,
				y: (sticker.yPercent / 100) * ch,
			};
		}
		return { x: sticker.x ?? 0, y: sticker.y ?? 0 };
	};

	// Cargar imágenes de stickers cuando cambia la página actual
	useEffect(() => {
		const loadStickerImages = async () => {
			if (
				!pages.length ||
				currentPageIndex < 0 ||
				currentPageIndex >= pages.length
			)
				return;

			const currentPage = pages[currentPageIndex];
			if (!currentPage) return;

			const imagesToLoad = {};

			// Cargar imágenes de canvasImages
			const canvasImages =
				currentPage.canvasImages || currentPage.data?.canvasImages || [];
			for (const img of canvasImages) {
				if (img.imageUrl && !loadedImages[img.id]) {
					const imageObj = new window.Image();
					imageObj.crossOrigin = "anonymous";

					try {
						if (img.imageUrl.startsWith("data:")) {
							imageObj.src = img.imageUrl;
						} else {
							imageObj.src = getAuthenticatedUrl(img.imageUrl);
						}

						await new Promise((resolve, reject) => {
							imageObj.onload = () => {
								// Verificar que la imagen esté completamente cargada y no esté rota
								if (
									imageObj.complete &&
									imageObj.naturalWidth > 0 &&
									imageObj.naturalHeight > 0
								) {
									resolve();
								} else {
									reject(new Error("Image is in broken state"));
								}
							};
							imageObj.onerror = (e) => {
								console.error("Error loading image:", img.imageUrl, e);
								reject(e);
							};
						});

						imagesToLoad[img.id] = imageObj;
					} catch (error) {
						console.error("Error loading image:", error, img.imageUrl);
						// No añadir la imagen a loadedImages si falla
					}
				}
			}

			// Cargar imágenes de canvasStickers
			const canvasStickers =
				currentPage.canvasStickers || currentPage.data?.canvasStickers || [];
			for (const sticker of canvasStickers) {
				if (
					(sticker.imagePath || sticker.assetId) &&
					!loadedImages[sticker.id]
				) {
					const imageObj = new window.Image();
					imageObj.crossOrigin = "anonymous";

					try {
						const stickerUrl = sticker.assetId
							? getStickerAssetUrl(sticker.assetId)
							: getAuthenticatedUrl(sticker.imagePath);
						imageObj.src = stickerUrl;
						await new Promise((resolve, reject) => {
							imageObj.onload = () => {
								// Verificar que la imagen esté completamente cargada y no esté rota
								if (
									imageObj.complete &&
									imageObj.naturalWidth > 0 &&
									imageObj.naturalHeight > 0
								) {
									resolve();
								} else {
									reject(new Error("Image is in broken state"));
								}
							};
							imageObj.onerror = (e) => {
								console.error(
									"Error loading sticker image:",
									sticker.imagePath,
									e,
								);
								reject(e);
							};
						});

						imagesToLoad[sticker.id] = imageObj;
					} catch (error) {
						console.error(
							"Error loading sticker image:",
							error,
							sticker.imagePath,
						);
						// No añadir la imagen a loadedImages si falla
					}
				}
			}

			if (Object.keys(imagesToLoad).length > 0) {
				setLoadedImages((prev) => ({ ...prev, ...imagesToLoad }));
			}
		};

		loadStickerImages();
	}, [currentPageIndex, pages, loadedImages]);

	useEffect(() => {
		const loadGuide = async () => {
			try {
				let data = null;
				if (isPrebuilt && guideId) {
					data = await getPrebuiltGuidePreview(guideId);
				} else if (token) {
					data = await getSharedGuide(token);
				}
				if (data && data.project) {
					console.log("Project backgroundColor:", data.project.backgroundColor);
					setProject(data.project);
					// Ordenar páginas por order
					const sortedPages = [...(data.project.pages || [])].sort((a, b) => {
						const orderA =
							a.data?.order !== undefined ? a.data.order : a.order || 0;
						const orderB =
							b.data?.order !== undefined ? b.data.order : b.order || 0;
						return orderA - orderB;
					});
					// Autenticar URLs HTTP de imágenes (prebuilt guide assets, uploads)
					for (const pg of sortedPages) {
						const authImages = (arr) => {
							if (!Array.isArray(arr)) return;
							for (const img of arr) {
								if (
									img &&
									typeof img === "object" &&
									img.src &&
									!img.src.startsWith("data:")
								) {
									img.src = getAuthenticatedUrl(img.src);
								}
							}
						};
						const authCanvasImages = (arr) => {
							if (!Array.isArray(arr)) return;
							for (const img of arr) {
								if (
									img &&
									typeof img === "object" &&
									img.imageUrl &&
									!img.imageUrl.startsWith("data:")
								) {
									img.imageUrl = getAuthenticatedUrl(img.imageUrl);
								}
							}
						};
						const authDiasExtras = (arr) => {
							if (!Array.isArray(arr)) return;
							for (const item of arr) {
								if (
									item?.image &&
									typeof item.image === "string" &&
									!item.image.startsWith("data:")
								) {
									item.image = getAuthenticatedUrl(item.image);
								}
							}
						};
						// Top-level (lo que leen los templates)
						authImages(pg.images);
						authCanvasImages(pg.canvasImages);
						authDiasExtras(pg.dias);
						authDiasExtras(pg.extras);
						// Template305 (menú de ciudades) usa la misma forma `{ image }`
						// que los días/extras, así que reutilizamos `authDiasExtras`.
						authDiasExtras(pg.ciudades);
						// data level (por si algo lee page.data.xxx)
						if (pg.data) {
							authImages(pg.data.images);
							authCanvasImages(pg.data.canvasImages);
							authDiasExtras(pg.data.dias);
							authDiasExtras(pg.data.extras);
							authDiasExtras(pg.data.ciudades);
						}
					}
					setPages(sortedPages);
					setPreviewAccess(isPrebuilt && data.access ? data.access : null);
					setIsSharedPublic(!isPrebuilt && data.isPublic === true);
					setError(null);
					setErrorType(null);
					if (isPrebuilt && guideId) {
						trackEvent("view_prebuilt_guide", {
							guide_id: String(guideId),
							guide_name: data.project.name,
							total_pages: sortedPages.length,
						});
					} else if (token) {
						trackEvent("view_shared_guide", {
							guide_name: data.project.name,
							total_pages: sortedPages.length,
						});
					}
				} else {
					setError("Guía no encontrada");
					setErrorType("not_found");
				}
			} catch (error) {
				console.error("Error loading guide:", error);

				// Determinar el tipo de error basado en el código de estado HTTP
				const status = error.status ?? error.response?.status;
				const errorMessage = error.message || "";
				const errorCode = error.response?.data?.error;

				if (errorCode === "GUIDE_COMING_SOON") {
					setError(
						error.response?.data?.message || "Próximamente disponible",
					);
					setErrorType("coming_soon");
				} else if (errorCode === "TEMPLATE_CANNOT_BE_VIEWED_PUBLICLY") {
					setError("Esta guía no está disponible con enlace público.");
					setErrorType("forbidden");
				} else if (status === 0 || errorMessage.includes("Failed to fetch")) {
					setError(
						"No se pudo conectar con el servidor. Comprueba que el backend esté en marcha (por ejemplo en http://localhost:3001).",
					);
					setErrorType("network");
				} else if (
					status === 401 ||
					errorMessage.includes("privada") ||
					errorMessage.includes("iniciar sesión")
				) {
					setError("Debes iniciar sesión para ver esta guía.");
					setErrorType("private");
				} else if (status === 403 || errorMessage.includes("permiso")) {
					setError("No tienes permiso para acceder a esta guía.");
					setErrorType("forbidden");
				} else if (status === 404 || errorMessage.includes("no encontrada")) {
					setError(
						"Guía no encontrada. La guía que buscas no existe o ha sido eliminada.",
					);
					setErrorType("not_found");
				} else {
					setError(
						"Error al cargar la guía. Por favor, intenta de nuevo más tarde.",
					);
					setErrorType("unknown");
				}
			} finally {
				setLoading(false);
			}
		};

		if (token || (isPrebuilt && guideId)) {
			setLoading(true);
			loadGuide();
		}
	}, [token, guideId, isPrebuilt, getSharedGuide, getPrebuiltGuidePreview]);

	// Cuando las fuentes terminan de cargar, forzar re-mount de textos Konva para recalcular métricas
	// (evita que el texto se desplace dentro de su box tras reload).
	useEffect(() => {
		let cancelled = false;
		const refresh = () => {
			if (cancelled) return;
			setFontsReadyKey((k) => k + 1);
		};
		if (document?.fonts?.ready?.then) {
			document.fonts.ready.then(refresh);
		} else {
			setTimeout(refresh, 0);
		}
		return () => {
			cancelled = true;
		};
	}, [currentPageIndex, pages.length]);

	// Guías prebuilt (vista previa o importada): que las <img> que apuntan al API envíen la cookie (crossOrigin) para que el backend autentique
	useEffect(() => {
		const useBackendImages = isPrebuilt || project?.prebuiltGuideId;
		if (!useBackendImages || !templateContainerRef.current) return;
		const origin = getApiOrigin();
		const imgs = templateContainerRef.current.querySelectorAll("img[src]");
		imgs.forEach((img) => {
			if (img.getAttribute("src")?.startsWith(origin)) {
				img.setAttribute("crossorigin", "use-credentials");
			}
		});
	}, [isPrebuilt, project?.prebuiltGuideId, currentPageIndex, pages]);

	useEffect(() => {
		prevPageIndexRef.current = currentPageIndex;
	}, [currentPageIndex]);

	const navigateToPage = (index) => {
		const num = index + 1;
		const gId = isPrebuilt ? guideId : token;
		trackEvent("viewer_page_navigated", {
			guide_id: gId ? String(gId) : undefined,
			page_index: index,
			page_number: num,
			total_pages: pages.length,
			guide_name: project?.name,
		});
		const basePath =
			isPrebuilt && guideId ? `/preview/prebuilt/${guideId}` : `/view/${token}`;
		navigate(`${basePath}/${num}`, { state: location.state });
		setTimeout(() => {
			const pageContent = pageContentRef.current || document.querySelector(".viewer-page-content");
			if (pageContent) {
				pageContent.scrollTo({ top: 0, behavior: "smooth" });
			}
			// En iOS, si el scroll se ha escapado al window/body, devolverlo a 0
			window.scrollTo(0, 0);
			if (document.documentElement) document.documentElement.scrollTop = 0;
			if (document.body) document.body.scrollTop = 0;
		}, 100);
	};

	const handleTouchStart = (e) => {
		const touch = e.touches[0];
		touchStartX.current = touch.clientX;
		touchStartY.current = touch.clientY;
	};

	const isPreviewLimited = isPrebuilt && previewAccess?.isLimited;
	const totalSlots = isPreviewLimited ? pages.length + 1 : pages.length;
	const isOnUnlockPage = isPreviewLimited && currentPageIndex === pages.length;

	// Ajustar índice si se pasa del total (p. ej. tras cargar vista previa limitada)
	useEffect(() => {
		if (currentPageIndex >= totalSlots && totalSlots > 0) {
			const num = totalSlots;
			const basePath =
				isPrebuilt && guideId
					? `/preview/prebuilt/${guideId}`
					: `/view/${token}`;
			navigate(`${basePath}/${num}`, { replace: true, state: location.state });
		}
	}, [totalSlots, currentPageIndex, navigate, isPrebuilt, guideId, token, location.state]);

	const handleViewerBack = () => {
		const from = location.state?.from;
		const safeFrom =
			typeof from === "string" &&
			from.startsWith("/") &&
			!from.startsWith("//") &&
			!from.startsWith("/preview/") &&
			!from.startsWith("/view/");
		if (safeFrom) {
			navigate(from);
			return;
		}
		if (isPrebuilt && guideId) {
			const landing = guideLandingPath(guideId);
			if (landing) {
				navigate(landing);
				return;
			}
		}
		navigate("/");
	};

	const handleTouchEnd = (e) => {
		const touch = e.changedTouches[0];
		const deltaX = touch.clientX - touchStartX.current;
		const deltaY = touch.clientY - touchStartY.current;

		if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > 50) {
			if (deltaX > 0 && currentPageIndex > 0) {
				navigateToPage(currentPageIndex - 1);
			} else if (deltaX < 0 && currentPageIndex < totalSlots - 1) {
				navigateToPage(currentPageIndex + 1);
			}
		}
	};

	const clearTextSelection = () => {
		const sel = window.getSelection();
		if (sel && sel.rangeCount > 0) sel.removeAllRanges();
	};

	const goNext = () => {
		clearTextSelection();
		if (currentPageIndex < totalSlots - 1) {
			navigateToPage(currentPageIndex + 1);
		}
	};

	const goPrevious = () => {
		clearTextSelection();
		if (currentPageIndex > 0) {
			navigateToPage(currentPageIndex - 1);
		}
	};

	const goToMenu = () => {
		clearTextSelection();
		// Ir a la página del plan (menú: templates 24, 50 Tokio, 52/183 Kioto, 71 NY, 110 Londres, 124, 129 Seúl, etc.)
		const planPageIndex = pages.findIndex(
			(page) =>
				page.data?.templateId === 24 ||
				page.templateId === 24 ||
				page.data?.templateId === 50 ||
				page.templateId === 50 ||
				page.data?.templateId === 52 ||
				page.templateId === 52 ||
				page.data?.templateId === 71 ||
				page.templateId === 71 ||
				page.data?.templateId === 110 ||
				page.templateId === 110 ||
				page.data?.templateId === 310 ||
				page.templateId === 310 ||
				page.data?.templateId === 124 ||
				page.templateId === 124 ||
				page.data?.templateId === 324 ||
				page.templateId === 324 ||
				page.data?.templateId === 129 ||
				page.templateId === 129 ||
				page.data?.templateId === 183 ||
				page.templateId === 183 ||
				page.data?.templateId === 264 ||
				page.templateId === 264 ||
				page.data?.templateId === 303 ||
				page.templateId === 303 ||
				page.data?.templateId === 304 ||
				page.templateId === 304 ||
				page.data?.order === 1 ||
				page.order === 1,
		);
		if (planPageIndex !== -1) {
			navigateToPage(planPageIndex);
		} else if (pages.length > 1) {
			navigateToPage(1);
		} else {
			navigateToPage(0);
		}
	};

	// Navegar a una página por id o por índice (usado por la pantalla menú - templates 24, 71, 124, 282 - al hacer clic en un ítem)
	const handleNavigateToPage = (pageIdOrIndex) => {
		if (pageIdOrIndex == null) return;
		let idx = -1;
		if (
			typeof pageIdOrIndex === "number" &&
			pageIdOrIndex >= 0 &&
			pageIdOrIndex < pages.length
		) {
			idx = pageIdOrIndex;
		} else {
			idx = pages.findIndex(
				(p) => String(p.id || p.data?.id || "") === String(pageIdOrIndex),
			);
		}
		if (idx !== -1) {
			navigateToPage(idx);
		}
	};

	// Actualizar dimensiones del canvas y rects de bloques [data-block-id] (como en StickerApp)
	useEffect(() => {
		const targetElement = document.getElementById("viewer-page-inner");
		if (!targetElement) return;

		const cp = pages[currentPageIndex];
		const rawTid = cp?.data?.templateId ?? cp?.templateId;
		const tid = rawTid != null && rawTid !== "" ? Number(rawTid) : 1;
		const isT1to22 = tid >= 1 && tid <= 22;

		const updateCanvasDimensions = () => {
			const el = document.getElementById("viewer-page-inner");
			if (!el) return;
			const width = el.offsetWidth;
			const height = isT1to22 ? el.scrollHeight : el.offsetHeight;
			if (width > 0 && height > 0) {
				setCanvasDimensions({ width, height });

				const updateBlockRects = () => {
					const target = el;
					const stageW = target.offsetWidth;
					const stageH = isT1to22 ? target.scrollHeight : target.offsetHeight;
					if (stageW <= 0 || stageH <= 0) return;
					const blocks = target.querySelectorAll("[data-block-id]");
					const targetRect = target.getBoundingClientRect();
					const scrollTop = isT1to22 ? target.scrollTop : 0;
					const refH = isT1to22 ? target.scrollHeight : targetRect.height;
					const next = {};
					blocks.forEach((blockEl) => {
						const id = blockEl.getAttribute("data-block-id");
						if (!id) return;
						const r = blockEl.getBoundingClientRect();
						const left =
							((r.left - targetRect.left) / targetRect.width) * stageW;
						const top = ((r.top - targetRect.top + scrollTop) / refH) * stageH;
						const blockWidth = (r.width / targetRect.width) * stageW;
						const blockHeight = (r.height / targetRect.height) * stageH;
						next[id] = { left, top, width: blockWidth, height: blockHeight };
					});
					setBlockRects((prev) => {
						const same =
							Object.keys(prev).length === Object.keys(next).length &&
							Object.keys(next).every(
								(k) =>
									prev[k] &&
									prev[k].left === next[k].left &&
									prev[k].top === next[k].top &&
									prev[k].width === next[k].width &&
									prev[k].height === next[k].height,
							);
						return same ? prev : next;
					});
				};

				setTimeout(() => {
					updateBlockRects();
					const konvajsContent = el.querySelector(".konvajs-content");
					if (konvajsContent) {
						konvajsContent.style.width = `${width}px`;
						konvajsContent.style.height = `${height}px`;
					}
				}, 0);
			}
		};

		const timeoutId = setTimeout(updateCanvasDimensions, 100);

		const resizeObserver = new ResizeObserver(updateCanvasDimensions);
		resizeObserver.observe(targetElement);

		if (isT1to22 && templateContainerRef.current) {
			resizeObserver.observe(templateContainerRef.current);
		}

		return () => {
			clearTimeout(timeoutId);
			resizeObserver.disconnect();
		};
	}, [currentPageIndex, pages]);

	const previewSeo = isPrebuilt ? (
		<SeoHead
			title={project?.name ? `Vista previa · ${project.name}` : "Vista previa"}
			noIndex
		/>
	) : null;

	if (loading) {
		return (
			<Box
				sx={{
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					height: "100vh",
				}}
			>
				{previewSeo}
				<CircularProgress />
			</Box>
		);
	}

	if (error || (!project && !loading)) {
		return (
			<Box
				sx={{
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					height: "100vh",
					flexDirection: "column",
					gap: 2,
					padding: 3,
					backgroundColor: "#f7f7f7",
				}}
			>
				{previewSeo}
				{errorType === "network" ? (
					<>
						<Typography variant="h5" sx={{ fontWeight: 600, color: "#333" }}>
							Error de conexión
						</Typography>
						<Typography
							variant="body1"
							color="text.secondary"
							textAlign="center"
							sx={{ maxWidth: 400, marginBottom: 2 }}
						>
							{error}
						</Typography>
						<Button
							variant="outlined"
							onClick={() => (window.location.href = "/")}
							sx={{
								borderColor: "rgb(47, 127, 224)",
								color: "rgb(47, 127, 224)",
								"&:hover": {
									borderColor: "rgb(47, 127, 224)",
									backgroundColor: "rgba(47, 127, 224, 0.1)",
								},
								padding: "10px 24px",
							}}
						>
							Volver al inicio
						</Button>
					</>
				) : errorType === "private" ? (
					<>
						<Typography variant="h5" sx={{ fontWeight: 600, color: "#333" }}>
							Guía Privada
						</Typography>
						<Typography
							variant="body1"
							color="text.secondary"
							textAlign="center"
							sx={{ maxWidth: 400, marginBottom: 1 }}
						>
							Esta guía es privada y solo está disponible para usuarios
							autenticados.
						</Typography>
						<Typography
							variant="body2"
							color="text.secondary"
							textAlign="center"
							sx={{ maxWidth: 400, marginBottom: 3 }}
						>
							Inicia sesión para acceder a esta guía.
						</Typography>
						<Button
							variant="contained"
							onClick={() => (window.location.href = "/")}
							sx={{
								backgroundColor: "rgb(47, 127, 224)",
								"&:hover": {
									backgroundColor: "rgb(47, 127, 224)",
								},
								padding: "10px 24px",
								fontSize: "16px",
								fontWeight: 600,
							}}
						>
							Iniciar Sesión
						</Button>
					</>
				) : errorType === "forbidden" ? (
					<>
						<Typography variant="h5" sx={{ fontWeight: 600, color: "#333" }}>
							Acceso Denegado
						</Typography>
						<Typography
							variant="body1"
							color="text.secondary"
							textAlign="center"
							sx={{ maxWidth: 400 }}
						>
							No tienes permiso para acceder a esta guía.
						</Typography>
						<Button
							variant="outlined"
							onClick={() => (window.location.href = "/")}
							sx={{
								borderColor: "rgb(47, 127, 224)",
								color: "rgb(47, 127, 224)",
								"&:hover": {
									borderColor: "rgb(47, 127, 224)",
									backgroundColor: "rgba(47, 127, 224, 0.1)",
								},
								marginTop: 2,
								padding: "10px 24px",
							}}
						>
							Volver al Inicio
						</Button>
					</>
				) : errorType === "coming_soon" ? (
					<>
						<Typography variant="h5" sx={{ fontWeight: 600, color: "#333" }}>
							Próximamente disponible
						</Typography>
						<Typography
							variant="body1"
							color="text.secondary"
							textAlign="center"
							sx={{ maxWidth: 400, marginBottom: 2 }}
						>
							{error}
						</Typography>
						<Button
							variant="contained"
							onClick={() => (window.location.href = "/explorar")}
							sx={{
								textTransform: "none",
								fontWeight: 600,
								fontSize: "0.938rem",
								background: "linear-gradient(135deg, #6366F1 0%, #8B5CF6 100%)",
								borderRadius: "12px",
								px: 3,
								py: 1.25,
								marginTop: 1,
								boxShadow: "0 4px 14px rgba(99, 102, 241, 0.35)",
								"&:hover": {
									background: "linear-gradient(135deg, #5558E3 0%, #7C4DE8 100%)",
									boxShadow: "0 6px 20px rgba(99, 102, 241, 0.45)",
								},
							}}
						>
							Explorar guías
						</Button>
					</>
				) : (
					<>
						<Typography variant="h5" sx={{ fontWeight: 600, color: "#333" }}>
							Guía no encontrada
						</Typography>
						<Typography
							variant="body1"
							color="text.secondary"
							textAlign="center"
							sx={{ maxWidth: 400, marginBottom: 1 }}
						>
							{error || "La guía que buscas no existe o ha sido eliminada."}
						</Typography>
						<Typography
							variant="body2"
							color="text.secondary"
							textAlign="center"
							sx={{ maxWidth: 400 }}
						>
							Verifica que la URL sea correcta o contacta al propietario de la
							guía.
						</Typography>
						<Button
							variant="outlined"
							onClick={() => (window.location.href = "/")}
							sx={{
								borderColor: "rgb(47, 127, 224)",
								color: "rgb(47, 127, 224)",
								"&:hover": {
									borderColor: "rgb(47, 127, 224)",
									backgroundColor: "rgba(47, 127, 224, 0.1)",
								},
								marginTop: 2,
								padding: "10px 24px",
							}}
						>
							Volver al Inicio
						</Button>
					</>
				)}
			</Box>
		);
	}

	if (!project || pages.length === 0) {
		return (
			<Box
				sx={{
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					height: "100vh",
					flexDirection: "column",
					gap: 2,
				}}
			>
				{previewSeo}
				<Typography variant="h5">Guía no encontrada</Typography>
				<Typography variant="body2" color="text.secondary">
					La guía que buscas no existe o ha sido eliminada.
				</Typography>
			</Box>
		);
	}

	const currentPage = isOnUnlockPage ? null : pages[currentPageIndex];
	if (!isOnUnlockPage && !currentPage) {
		return (
			<Box
				sx={{
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					height: "100vh",
				}}
			>
				<CircularProgress />
			</Box>
		);
	}

	// Variables de template solo cuando no estamos en la página CTA "Desbloquea"
	let rawTemplateId,
		templateId,
		CurrentTemplate,
		normalizedPage,
		isMenuTemplate,
		isTravelKitTemplate,
		isViewerTemplate1to22,
		canvasImages,
		canvasStickers,
		canvasTexts,
		notes;
	if (!isOnUnlockPage && currentPage) {
		rawTemplateId = currentPage?.data?.templateId ?? currentPage?.templateId;
		templateId =
			rawTemplateId !== undefined &&
			rawTemplateId !== null &&
			rawTemplateId !== ""
				? Number(rawTemplateId)
				: 1;
		CurrentTemplate =
			templatesById[templateId < 23 ? templateId + 1 : templateId] ?? Template1;
		normalizedPage =
			currentPage?.data != null
				? { ...currentPage, ...currentPage.data }
				: currentPage;

		// Authenticate dias/extras image URLs at render time so menu templates
		// always receive URLs with the current JWT token.
		{
			const jwt = localStorage.getItem("token");
			if (jwt && normalizedPage) {
				const _addTk = (url) => {
					if (!url || typeof url !== "string" || url.startsWith("data:"))
						return url;
					try {
						const u = new URL(url, window.location.origin);
						u.searchParams.set("token", jwt);
						return u.toString();
					} catch {
						return url;
					}
				};
				const _authArr = (arr) => {
					if (!Array.isArray(arr)) return arr;
					return arr.map((item) =>
						item?.image ? { ...item, image: _addTk(item.image) } : item,
					);
				};
				const srcDias = normalizedPage.data?.dias ?? normalizedPage.dias;
				const srcExtras = normalizedPage.data?.extras ?? normalizedPage.extras;
				if (Array.isArray(srcDias) || Array.isArray(srcExtras)) {
					const newDias = _authArr(srcDias);
					const newExtras = _authArr(srcExtras);
					normalizedPage = {
						...normalizedPage,
						dias: newDias,
						extras: newExtras,
						data: normalizedPage.data
							? { ...normalizedPage.data, dias: newDias, extras: newExtras }
							: normalizedPage.data,
					};
				}
			}
		}

		isMenuTemplate =
			templateId === 24 ||
			templateId === 50 ||
			templateId === 52 ||
			templateId === 71 ||
			templateId === 110 ||
			templateId === 310 ||
			templateId === 124 ||
			templateId === 324 ||
			templateId === 129 ||
			templateId === 150 ||
			templateId === 168 ||
			templateId === 183 ||
			templateId === 264 ||
			templateId === 282 ||
			templateId === 303 ||
			templateId === 304 ||
			templateId === 305;
		isTravelKitTemplate = templateId >= 101 && templateId <= 106;
		isViewerTemplate1to22 = templateId >= 1 && templateId <= 22;
		canvasImages =
			currentPage.canvasImages || currentPage.data?.canvasImages || [];
		canvasStickers =
			currentPage.canvasStickers || currentPage.data?.canvasStickers || [];
		canvasTexts =
			currentPage.canvasTexts || currentPage.data?.canvasTexts || [];
		notes = currentPage.notes || currentPage.data?.notes || [];
	} else {
		CurrentTemplate = Template1;
		normalizedPage = {};
		isMenuTemplate = false;
		isTravelKitTemplate = false;
		isViewerTemplate1to22 = false;
		canvasImages = [];
		canvasStickers = [];
		canvasTexts = [];
		notes = [];
	}

	// Actualizar página en Viewer (guía compartida): estado local + API para persistir checklist etc.
	// Preservar siempre data.templateId para que el siguiente render use la template correcta.
	const handleUpdatePage = (updatedPage) => {
		if (!updatedPage || !updatedPage.id) return;
		const baseData = updatedPage.data ?? currentPage?.data;
		const dataToStore =
			baseData != null && typeof baseData === "object"
				? {
						...baseData,
						templateId: baseData.templateId ?? currentPage?.data?.templateId,
					}
				: baseData;
		setPages((prev) =>
			prev.map((p) =>
				p.id === updatedPage.id
					? { ...p, ...updatedPage, data: dataToStore }
					: p,
			),
		);
		if (token && !isPrebuilt && updateSharedGuidePage) {
			const payloadData =
				dataToStore != null && typeof dataToStore === "object"
					? {
							...dataToStore,
							...updatedPage,
							templateId:
								dataToStore.templateId ?? currentPage?.data?.templateId,
						}
					: dataToStore;
			updateSharedGuidePage(token, updatedPage.id, payloadData);
		}
	};

	// canvasImages, canvasStickers, canvasTexts ya definidos arriba según isOnUnlockPage

	// Asegurar que el backgroundColor se use correctamente
	// Si project.backgroundColor es null, undefined, o vacío, usar el color por defecto de las guías preconstruidas
	const bgColor =
		project?.backgroundColor && project.backgroundColor.trim() !== ""
			? project.backgroundColor
			: "#d2ebf0";

	// Log para depuración
	if (!project?.backgroundColor || project.backgroundColor.trim() === "") {
		console.warn(
			"⚠️ project.backgroundColor está vacío o es null. Usando color por defecto:",
			bgColor,
		);
		console.log("Project completo:", project);
	} else {
		console.log("✅ Usando backgroundColor del proyecto:", bgColor);
	}

	const primaryColor = project?.headerBackgroundColor?.trim() || "#2f7fe0";
	const showBranding = isSharedPublic && !project?.prebuiltGuideId;

	// Base URL para imágenes: backend cuando es guía prebuilt (vista previa o importada).
	// Carpeta de assets según guía: ny → ny, tokio/kioto → japon, seul → seul, etc.
	const prebuiltGuideId = guideId || project?.prebuiltGuideId;
	const useBackendImages = isPrebuilt || project?.prebuiltGuideId;
	const prebuiltAssetsFolder =
		prebuiltGuideId === "tokio" || prebuiltGuideId === "kioto"
			? "japon"
			: prebuiltGuideId === "seul"
				? "seul"
				: prebuiltGuideId === "ny"
					? "ny"
					: prebuiltGuideId === "londres"
						? "londres"
						: prebuiltGuideId === "paris"
							? "paris"
							: prebuiltGuideId === "bangkok"
								? "bangkok"
								: prebuiltGuideId === "osaka"
									? "japon"
									: prebuiltGuideId === "edimburgo"
										? "edimburgo"
										: "ny";
	const imageBaseUrl =
		useBackendImages && prebuiltGuideId
			? `${getApiOrigin()}/api/prebuilt-guides/${prebuiltGuideId}/assets/images/${prebuiltAssetsFolder}/`
			: null;

	return (
		<MapFullscreenContext.Provider value={{ mapFullscreen, setMapFullscreen }}>
			{previewSeo}
			<Box
				sx={{
					width: "100%",
					minHeight: "100vh",
					backgroundColor: "#fff",
					display: "flex",
					flexDirection: "column",
				}}
			>
				{/* Volver: oculto cuando el mapa está en grande (solo se muestra "Volver a la guía") */}
				{typeof document !== "undefined" &&
					!mapFullscreen &&
					createPortal(
						<Box
							onClick={handleViewerBack}
							onMouseDown={(e) => e.preventDefault()}
							onContextMenu={(e) => e.preventDefault()}
							sx={{
								position: "fixed",
								top: 12,
								left: 12,
								zIndex: 9999999,
								display: "flex",
								alignItems: "center",
								gap: 0.5,
								padding: "6px 6px",
								borderRadius: "20px",
								backgroundColor: "rgba(255, 255, 255, 0.95)",
								color: primaryColor,
								fontSize: "0.875rem",
								fontWeight: 600,
								cursor: "pointer",
								boxShadow: "0 2px 10px rgba(0,0,0,0.12)",
								border: "1px solid rgba(0,0,0,0.08)",
								backdropFilter: "blur(8px)",
								WebkitBackdropFilter: "blur(8px)",
								transition: "background-color 0.2s, box-shadow 0.2s",
								pointerEvents: "auto",
								userSelect: "none",
								WebkitUserSelect: "none",
								WebkitTapHighlightColor: "transparent",
								touchAction: "manipulation",
								"&:hover": {
									backgroundColor: "#fff",
									boxShadow: "0 2px 12px rgba(0,0,0,0.15)",
								},
							}}
						>
							<ArrowBackIcon sx={{ fontSize: 18 }} />
						</Box>,
						document.body,
					)}

				<Box
					ref={pageContentRef}
					className="viewer-page-content"
					onTouchStart={handleTouchStart}
					onTouchEnd={handleTouchEnd}
					sx={{
						height: showBranding ? "calc(100dvh - 72px)" : "calc(100dvh - 52px)",
						overflowY: "auto",
						overflowX: "hidden",
						width: "100%",
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
						padding: { xs: "20px 19px", sm: "2px" },
						borderRadius: "12px",
						// iOS: contener el scroll aquí y evitar que se enganche en la ventana al mostrar/ocultar barra URL
						overscrollBehavior: "contain",
						WebkitOverflowScrolling: "touch",
						touchAction: "pan-y",
					}}
				>
					<Box
						sx={{
							width: "100%",
							maxWidth: "550px",
							height: "min(765px,100%)",
							position: "relative",
							overflow: "hidden",
							borderRadius: "12px",
							boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
							"@keyframes viewerSlideNext": {
								from: { transform: "translateX(100%)", opacity: 0 },
								to: { transform: "translateX(0)", opacity: 1 },
							},
							"@keyframes viewerSlidePrev": {
								from: { transform: "translateX(-100%)", opacity: 0 },
								to: { transform: "translateX(0)", opacity: 1 },
							},
						}}
					>
						<Box
							key={currentPageIndex}
							sx={{
								width: "100%",
								height: "100%",
								animation:
									direction === "next"
										? "viewerSlideNext 0.4s ease-in-out"
										: "viewerSlidePrev 0.4s ease-in-out",
							}}
						>
							<Box
								id="viewer-page-inner"
								ref={viewerPageInnerRef}
								className={
									[
										isTravelKitTemplate && "viewer-travelkit",
										isViewerTemplate1to22 && "viewer-templates-1-22",
									]
										.filter(Boolean)
										.join(" ") || undefined
								}
								sx={{
									width: "100%",
									maxWidth: "550px",
									//minHeight: "100%",
									height: "min(765px,100%)",
									alignItems: "center",
									//aspectRatio: "21 / 29.7",
									backgroundColor: isMenuTemplate ? "#f7f7f7" : bgColor,
									position: "relative",
									boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
									borderRadius: "12px",
									display: "flex",
									flexDirection: "column",
									overflowX: "hidden",
									...(isViewerTemplate1to22 && { overflowY: "auto" }),
								}}
							>
								{/* Vista previa limitada: página CTA "Desbloquea la guía" o contenido normal */}
								{isOnUnlockPage ? (
									<Box
										sx={{
											flex: 1,
											display: "flex",
											flexDirection: "column",
											alignItems: "center",
											justifyContent: "center",
											textAlign: "center",
											px: 2,
											py: 3,
										}}
									>
										<Box
											sx={{
												width: 72,
												height: 72,
												borderRadius: "50%",
												bgcolor: "rgba(99, 102, 241, 0.12)",
												display: "flex",
												alignItems: "center",
												justifyContent: "center",
												mb: 2,
											}}
										>
											<LockIcon sx={{ fontSize: 40, color: "#6366F1" }} />
										</Box>
										<Typography
											variant="h6"
											sx={{ fontWeight: 700, color: "#1a1a2e", mb: 1 }}
										>
											{previewAccess?.isFree
												? "Sigue leyendo gratis"
												: "Desbloquea esta guía"}
										</Typography>
										<Typography
											variant="body2"
											sx={{ color: "#64748B", mb: 2, maxWidth: 320 }}
										>
											{previewAccess?.isFree
												? `Has visto ${previewAccess?.visiblePages ?? 3} de ${previewAccess?.totalPages ?? "—"} páginas. Crea una cuenta gratis para ver el resto y guardar la guía.`
												: "Suscríbete a Pro o compra esta guía para ver todas las páginas y personalizarla."}
										</Typography>
										<Button
											variant="contained"
											startIcon={
												previewAccess?.isFree ? (
													<PersonAddAltIcon />
												) : (
													<ShoppingCartIcon />
												)
											}
											onClick={() =>
												previewAccess?.isFree
													? navigate("/explorar", {
															state: { showLogin: true, authMode: "signup" },
														})
													: navigate("/", {
															state: { openPurchaseForGuideId: guideId },
														})
											}
											sx={{
												textTransform: "none",
												fontWeight: 600,
												background:
													"linear-gradient(135deg, #6366F1 0%, #8B5CF6 100%)",
												borderRadius: "12px",
												px: 2.5,
												py: 1.25,
												boxShadow: "0 4px 14px rgba(99, 102, 241, 0.35)",
												"&:hover": {
													background:
														"linear-gradient(135deg, #5558E3 0%, #7C4DE8 100%)",
													boxShadow: "0 6px 20px rgba(99, 102, 241, 0.45)",
												},
											}}
										>
											{previewAccess?.isFree
												? "Crear cuenta gratis"
												: "Suscribirme o comprar"}
										</Button>
									</Box>
								) : (
									<>
										{/* Ocultar controles de edición en Travel Kit (101-106): regla inyectada aquí para máxima prioridad */}
										{isTravelKitTemplate && (
											<style>
												{`#viewer-page-inner.viewer-travelkit .hide-in-viewer,
[data-viewer-travelkit] .hide-in-viewer {
	display: none !important;
	visibility: hidden !important;
	pointer-events: none !important;
	opacity: 0 !important;
	width: 0 !important;
	height: 0 !important;
	min-width: 0 !important;
	min-height: 0 !important;
	overflow: hidden !important;
	margin: 0 !important;
	padding: 0 !important;
	border: none !important;
}`}
											</style>
										)}
										{/* Templates 1-22 en viewer: placeholders (texto e imagen) invisibles pero ocupan espacio */}
										{isViewerTemplate1to22 && (
											<style>
												{`#viewer-page-inner.viewer-templates-1-22 [data-image-placeholder],
#viewer-page-inner.viewer-templates-1-22 [data-text-placeholder],
#viewer-page-inner.viewer-templates-1-22 [data-map-placeholder],
#viewer-page-inner.viewer-templates-1-22 label:has(> [data-image-placeholder]) {
	visibility: hidden !important;
	pointer-events: none !important;
}
#viewer-page-inner.viewer-templates-1-22 [data-block-id*="image"] {
	background-color: transparent !important;
}`}
											</style>
										)}
										<Box
											ref={templateContainerRef}
											{...(isTravelKitTemplate
												? { "data-viewer-travelkit": "true" }
												: {})}
											sx={{
												flex: 1,
												display: "flex",
												flexDirection: "column",
												minHeight: "100%",
												width: "100%",
												position: "relative",
												zIndex: 1,
												isolation: "isolate",
												"& > div": {
													width: "100%",
												},
												// Header (primer hijo del wrapper) con zIndex alto en templates 23 y >= 25
												...((templateId === 23 || templateId >= 25) && {
													"& > * > *:first-child": { zIndex: 10002 },
												}),
											}}
										>
											<ViewerContext.Provider value={true}>
												<ImageBaseUrlProvider value={imageBaseUrl}>
													<CurrentTemplate
													headerTextColor={project.headerTextColor}
													headerBackgroundColor={project.headerBackgroundColor}
													backgroundColor={project.backgroundColor}
													textColor={project.textColor}
													fontFamily={project.fontFamily}
													page={normalizedPage}
													updatePage={
														isViewerTemplate1to22
															? () => {}
															: token && !isPrebuilt
																? handleUpdatePage
																: () => {}
													}
													onMapFullscreenChange={setMapFullscreen}
													onNavigateToPage={
														isMenuTemplate ? handleNavigateToPage : undefined
													}
													pages={isMenuTemplate ? pages : undefined}
													isViewer={true}
													prebuiltGuideId={prebuiltGuideId}
												/>
											</ImageBaseUrlProvider>
											</ViewerContext.Provider>
										</Box>
										{/* Canvas de Konva para mostrar stickers, imágenes y textos (medidas y scroll como en StickerApp) */}
										<Box
											ref={canvasContainerRef}
											sx={{
												position: "absolute",
												top: 0,
												left: 0,
												width: "100%",
												height: isViewerTemplate1to22
													? `${canvasDimensions.height}px`
													: "100%",
												overflowY: isViewerTemplate1to22 ? "hidden" : "auto",
												overflowX: "hidden",
												pointerEvents: "none",
												zIndex: 5000,
												"& .konvajs-content, & .konvajs-content canvas": {
													pointerEvents: "none !important",
												},
												"& .konvajs-content": {
													width: `${canvasDimensions.width}px !important`,
													height: `${canvasDimensions.height}px !important`,
												},
											}}
										>
											<Stage
												width={canvasDimensions.width}
												height={canvasDimensions.height}
												listening={false}
											>
												<Layer>
													{/* Renderizar canvasImages */}
													{canvasImages
														.filter((img) => !img.notShow)
														.filter((img) => {
															// Filtrar imágenes que son parte del template (para templates 23-43)
															if (templateId >= 23 && templateId <= 43) {
																const templateImageIds = [
																	"logo",
																	"sticker-1",
																	"sticker-2",
																	"yasaka-sticker",
																	"gion-sticker",
																	"portada-central",
																	"background-stickers",
																	"overlay-negro",
																	"sticker-arashiyama",
																	"sticker-bosque",
																	"ninenzaka-sticker",
																	"templo-dorado-sticker3",
																	"templo-dorado-sticker2",
																	"ryoanji-sticker",
																	"pontocho-sticker",
																	"nijo-sticker",
																	"monos-sticker",
																	"inari-sticker",
																	"nara-sticker",
																	"ciervos-sticker",
																	"camino-filosofia",
																	"autobus-kioto",
																	"train-sticker",
																	"ceremonia-te",
																	"kansai",
																	"consejos",
																	"enchufe",
																];
																return !templateImageIds.includes(img.id);
															}
															return true;
														})
														.map((img, index) => {
															const imageObj = loadedImages[img.id];
															if (!imageObj && img.imageUrl) {
																return null;
															}
															// Verificar que la imagen esté completamente cargada y no esté rota
															if (
																imageObj &&
																(!imageObj.complete ||
																	imageObj.naturalWidth === 0 ||
																	imageObj.naturalHeight === 0)
															) {
																console.warn(
																	"Image is in broken state, skipping render:",
																	img.id,
																	img.imageUrl,
																);
																return null;
															}
															return (
																<KonvaImage
																	key={`canvas-image-${img.id}-${index}`}
																	image={imageObj}
																	x={img.x || 0}
																	y={img.y || 0}
																	width={img.width || 100}
																	height={img.height || 100}
																	rotation={img.rotation || 0}
																	scaleX={img.scaleX || 1}
																	scaleY={img.scaleY || 1}
																/>
															);
														})}
													{/* Renderizar canvasStickers (posición y tamaño como en StickerApp: anchor/offset y widthPercent/aspectRatio) */}
													{canvasStickers
														.filter((sticker) => sticker.imagePath)
														.map((sticker, index) => {
															const imageObj = loadedImages[sticker.id];
															if (!imageObj) {
																return null;
															}
															// Verificar que la imagen esté completamente cargada y no esté rota
															if (
																!imageObj.complete ||
																imageObj.naturalWidth === 0 ||
																imageObj.naturalHeight === 0
															) {
																console.warn(
																	"Sticker image is in broken state, skipping render:",
																	sticker.id,
																	sticker.imagePath,
																);
																return null;
															}
															const scaledSize = getStickerScaledSize(sticker);
															const pos = getStickerPixelPosition(
																sticker,
																scaledSize.width,
																scaledSize.height,
															);
															const stickerKey = `canvas-sticker-${
																sticker.id || sticker.uniqueId
															}-${index}`;
															if (sticker.customText) {
																const layout = computeStickerTextLayout(
																	sticker.customText.value,
																	sticker.customText.config,
																	scaledSize.width,
																	scaledSize.height,
																);
																return (
																	<Group
																		key={stickerKey}
																		x={pos.x}
																		y={pos.y}
																		rotation={sticker.rotation || 0}
																		scaleX={sticker.scaleX || 1}
																		scaleY={sticker.scaleY || 1}
																	>
																		<KonvaImage
																			image={imageObj}
																			x={0}
																			y={0}
																			width={scaledSize.width}
																			height={scaledSize.height}
																			listening={false}
																		/>
																		{layout.curve ? (
																			<KonvaTextPath
																				x={0}
																				y={0}
																				data={layout.curve.pathAbs}
																				text={layout.text}
																				fontFamily={layout.fontFamily}
																				fontStyle={
																					layout.konvaFontStyle
																				}
																				fontSize={layout.fontSize}
																				fill={layout.color}
																				stroke={
																					layout.stroke || undefined
																				}
																				strokeWidth={
																					layout.strokeWidth || 0
																				}
																				fillAfterStrokeEnabled
																				letterSpacing={
																					layout.letterSpacing
																				}
																				align={layout.align}
																				shadowColor={
																					layout.shadow?.color
																				}
																				shadowOffsetX={
																					layout.shadow?.offsetX
																				}
																				shadowOffsetY={
																					layout.shadow?.offsetY
																				}
																				shadowBlur={layout.shadow?.blur}
																				shadowOpacity={
																					layout.shadow ? 1 : 0
																				}
																				listening={false}
																			/>
																		) : (
																			(() => {
																				const sX = layout.scaleX ?? 1;
																				const shiftX =
																					layout.align === "left"
																						? 0
																						: layout.align === "right"
																							? layout.rect.width *
																								(1 - sX)
																							: (layout.rect.width *
																									(1 - sX)) /
																								2;
																				return (
																					<KonvaText
																						x={layout.rect.x + shiftX}
																						y={
																							layout.rect.y +
																							(layout.rect.height -
																								layout.fontSize *
																									1.15) /
																								2
																						}
																						width={layout.rect.width}
																						scaleX={sX}
																						text={layout.text}
																						fontFamily={
																							layout.fontFamily
																						}
																						fontStyle={
																							layout.konvaFontStyle
																						}
																						fontSize={layout.fontSize}
																						fill={layout.color}
																						stroke={
																							layout.stroke ||
																							undefined
																						}
																						strokeWidth={
																							layout.strokeWidth || 0
																						}
																						fillAfterStrokeEnabled
																						letterSpacing={
																							layout.letterSpacing
																						}
																						align={layout.align}
																						lineHeight={1.15}
																						shadowColor={
																							layout.shadow?.color
																						}
																						shadowOffsetX={
																							layout.shadow?.offsetX
																						}
																						shadowOffsetY={
																							layout.shadow?.offsetY
																						}
																						shadowBlur={
																							layout.shadow?.blur
																						}
																						shadowOpacity={
																							layout.shadow ? 1 : 0
																						}
																						listening={false}
																					/>
																				);
																			})()
																		)}
																	</Group>
																);
															}
															return (
																<KonvaImage
																	key={stickerKey}
																	image={imageObj}
																	x={pos.x}
																	y={pos.y}
																	width={scaledSize.width}
																	height={scaledSize.height}
																	rotation={sticker.rotation || 0}
																	scaleX={sticker.scaleX || 1}
																	scaleY={sticker.scaleY || 1}
																/>
															);
														})}
													{/* Renderizar canvasTexts */}
													{canvasTexts.map((text, index) =>
														(() => {
															const pos = getTextPixelPosition(text);
															const dims = getTextDimensions(text);
															const fontSize = getTextFontSize(text);
															return (
																<KonvaText
																	key={`canvas-text-${fontsReadyKey}-${index}-${text.text}`}
																	x={pos.x}
																	y={pos.y}
																	text={text.text || ""}
																	fontSize={fontSize}
																	fontFamily={
																		text.fontFamily ||
																		project.fontFamily ||
																		"Montserrat"
																	}
																	fill={
																		text.fill ||
																		text.color ||
																		project.textColor ||
																		"#000000"
																	}
																	stroke={text.stroke || "#ffffff"}
																	strokeWidth={text.strokeWidth || 4}
																	fillAfterStrokeEnabled={true}
																	align={text.align || "left"}
																	width={dims.width}
																	height={dims.height}
																	scaleX={text.scaleX || 1}
																	scaleY={text.scaleY || 1}
																	rotation={text.rotation || 0}
																/>
															);
														})(),
													)}
												</Layer>
											</Stage>
										</Box>
										{/* Renderizar notas (con data-viewer-notes para que la excepción CSS re-active pointer-events) */}
										{notes && notes.length > 0 && (
											<Box
												data-viewer-notes
												sx={{
													position: "absolute",
													top: 0,
													left: 0,
													width: "100%",
													height: isViewerTemplate1to22
														? `${canvasDimensions.height}px`
														: "100%",
													pointerEvents: "none",
													zIndex: 10001,
												}}
											>
												{notes.map((note) => (
													<Box
														key={note.id}
														sx={{
															position: "absolute",
															left: `${note.x}%`,
															top: `${note.y}%`,
															pointerEvents: "auto",
														}}
													>
														<Note note={note} editMode={false} />
													</Box>
												))}
											</Box>
										)}
									</>
								)}
							</Box>
						</Box>
					</Box>

					{/* Botones de navegación: ocultos cuando el mapa está en vista grande (solo se muestra "Volver a la guía" del template) */}
					{!mapFullscreen &&
						(() => {
							const primaryColor =
								project?.headerBackgroundColor?.trim() || "#2f7fe0";
							const isFirstPage = currentPageIndex === 0;
							const isLastPage = currentPageIndex === totalSlots - 1;
							return (
								<Box
									sx={{
										position: "fixed",
										bottom: 0,
										left: 0,
										right: 0,
										backgroundColor: "#fff",
										display: "flex",
										flexDirection: "column",
										zIndex: 1000,
										borderTop: `1px solid rgba(0,0,0,0.06)`,
									}}
								>
								{showBranding && (
									<Box
										sx={{
											display: "flex",
											justifyContent: "center",
											alignItems: "center",
											py: 0.5,
											px: 2,
											backgroundColor: "rgba(99, 102, 241, 0.04)",
											borderBottom: "1px solid rgba(0,0,0,0.04)",
										}}
									>
										<Typography
											component="span"
											sx={{
												fontSize: 11,
												color: "#94a3b8",
												fontFamily: "'Inter', -apple-system, sans-serif",
												letterSpacing: "0.01em",
											}}
										>
											Esta guía fue creada con Viajes Molones{" · "}
											<Box
												component="a"
												href="/"
												sx={{
													color: "#6366F1",
													textDecoration: "none",
													fontWeight: 600,
													"&:hover": {
														textDecoration: "underline",
													},
												}}
											>
												Crea la tuya gratis
											</Box>
										</Typography>
									</Box>
								)}
								<Box
									sx={{
										padding: "5px 16px",
										display: "flex",
										justifyContent: "space-between",
										alignItems: "center",
									}}
								>
								<Box
									onClick={isFirstPage ? undefined : goPrevious}
									onMouseDown={(e) => e.preventDefault()}
									onContextMenu={(e) => e.preventDefault()}
									sx={{
										display: "flex",
										justifyContent: "center",
										alignItems: "center",
										gap: "4px",
										cursor: isFirstPage ? "not-allowed" : "pointer",
										opacity: isFirstPage ? 0.45 : 1,
										color: isFirstPage ? "#94a3b8" : primaryColor,
										fontWeight: 600,
										padding: "8px 16px",
										borderRadius: "8px",
										userSelect: "none",
										WebkitUserSelect: "none",
										WebkitTapHighlightColor: "transparent",
										touchAction: "manipulation",
										"&:hover": {
											backgroundColor: isFirstPage
												? "transparent"
												: `${primaryColor}14`,
										},
									}}
								>
									<ArrowBackIcon sx={{ fontSize: 18 }} /> Anterior
								</Box>

								<Box
									onClick={goToMenu}
									onMouseDown={(e) => e.preventDefault()}
									onContextMenu={(e) => e.preventDefault()}
									sx={{
										display: "flex",
										justifyContent: "center",
										alignItems: "center",
										gap: "4px",
										backgroundColor: "#fff",
										border: `2px solid ${primaryColor}`,
										color: primaryColor,
										padding: "8px 16px",
										borderRadius: "8px",
										cursor: "pointer",
										fontWeight: 600,
										userSelect: "none",
										WebkitUserSelect: "none",
										WebkitTapHighlightColor: "transparent",
										touchAction: "manipulation",
										"&:hover": {
											backgroundColor: `${primaryColor}0c`,
										},
									}}
								>
									Menú
								</Box>

								<Box
									onClick={isLastPage ? undefined : goNext}
									onMouseDown={(e) => e.preventDefault()}
									onContextMenu={(e) => e.preventDefault()}
									sx={{
										display: "flex",
										justifyContent: "center",
										alignItems: "center",
										gap: "4px",
										cursor: isLastPage ? "not-allowed" : "pointer",
										opacity: isLastPage ? 0.6 : 1,
										color: "#fff",
										backgroundColor: isLastPage ? "#94a3b8" : primaryColor,
										fontWeight: 600,
										padding: "8px 16px",
										borderRadius: "8px",
										userSelect: "none",
										WebkitUserSelect: "none",
										WebkitTapHighlightColor: "transparent",
										touchAction: "manipulation",
										"&:hover": {
											backgroundColor: isLastPage ? "#94a3b8" : undefined,
											filter: isLastPage ? "none" : "brightness(1.05)",
										},
									}}
								>
									Siguiente <ArrowForwardIcon sx={{ fontSize: 18 }} />
								</Box>
								</Box>
								</Box>
							);
						})()}
				</Box>
			</Box>
		</MapFullscreenContext.Provider>
	);
};

export default Viewer;
